
<template>
    <div class="slider7">
        <div class="title position-absolute"></div>
        <!-- Additional required wrapper -->
        <div class="cnt">
            <swiper :options="gameFeaturesOptions" ref="gameFeatures">
                <swiper-slide v-for="i in 5" :key="i">
                    <div class="img-size" :class="`swiper-slide-${i}`"></div>
                </swiper-slide>
            </swiper>

            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
        </div>

    </div>
</template>

<script>
export default {
    data() {
        return {

            gameFeaturesOptions: {
                effect: 'coverflow',
                loop: true,
                grabCursor: true,
                centeredSlides: true,
                slidesPerView: 'auto',
                autoplay: {
                    delay: 3000,
                },
                coverflowEffect: {
                    rotate: 0,
                    stretch: 0,
                    depth: 500,
                    modifier: 1,
                    slideShadows: false,
                },

                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
/* 外层容器 */
.slider7 {
    background: url("../../assets/img/m7/bg.png") no-repeat top;
    background-size: cover;
    width: 100%;
    height: 100%;
    position: relative;

    .title {
        background: url("../../assets/img/m7/title.png") no-repeat top;
        background-size: cover;
        width: 1066px;
        height: 140px;
        position: absolute;
        top: 123px;
        left: 318px;

    }

    .cnt {
        width: 1200px;
        height: 510px;
        position: relative;
        top: 300px;
        left: 50%;
        transform: translate(-50%, 0);

        /* 轮播项 */
        .swiper-slide {
            width: 80%;
            height: 100%;

            .img-size {
                width: 904px;
                height: 509px;
            }

            .swiper-slide-1 {
                background: url("../../assets/img/m7/img1.png") no-repeat top;
                background-size: 100% 100%;
            }

            .swiper-slide-2 {
                background: url("../../assets/img/m7/img2.png") no-repeat top;
                background-size: 100% 100%;
            }

            .swiper-slide-3 {
                background: url("../../assets/img/m7/img3.png") no-repeat top;
                background-size: 100% 100%;
            }
            .swiper-slide-4 {
                background: url("../../assets/img/m7/img4.png") no-repeat top;
                background-size: 100% 100%;
            }
            .swiper-slide-5 {
                background: url("../../assets/img/m7/img5.png") no-repeat top;
                background-size: 100% 100%;
            }

        }
        .swiper-button-prev:after {
            display: none;
        }

        .swiper-button-next:after {
            display: none;
        }
        .swiper-button-prev {
            background: url("../../assets/img/m7/prev.png") no-repeat top;
            background-size: cover;
            width: 27px;
            height: 37px;
        }

        .swiper-button-next {
            background: url("../../assets/img/m7/next.png") no-repeat top;
            background-size: cover;
            width: 27px;
            height: 37px;
        }
    }


}


@media screen and (min-width: 2560px) and (max-width: 3440px) {
    .slider7 {
        .title {
        width: 906px !important;
        height: 119px !important;
        top: 99px !important;

        
    }
    .cnt {
        width: 1020px !important;
        height: 433px !important;
        top: 250px !important;

        .img-size {
                width: 768px  !important;
                height: 432px  !important;
            }



    }
 
    }
  

}
</style>


// WEBPACK FOOTER //
// src/components/publicComponents/slider7.vue